import React, { useCallback } from 'react'
import { useNavigate, NavigateFunction } from 'react-router-dom'

import { SearchEdge, SearchObjectType } from '@/apollo/graphql'
import { Maybe } from '@/types'
import {
  carsPath,
  dealsPath,
  reportsPath,
  proposalPath,
  invoicesPath,
  makeSearchPath,
  mainInformationPath,
} from '@/utils/index'
import moment from 'moment'

interface Props {
  data: SearchEdge[]
}

const TBody: React.FC<Props> = ({ data }) => {
  const navigate: NavigateFunction = useNavigate()

  const onClickRow = useCallback(
    (node: Maybe<SearchObjectType>) => {
      if (!node?.objectType) return
      const isCustomer = node.objectType === 'Customer'
      let path = ''
      if (node.objectType === 'Car') {
        path = carsPath
      } else if (node.objectType === 'Deal') {
        path = dealsPath
      } else if (isCustomer) {
        path = dealsPath
      } else if (node.objectType === 'Report') {
        path = reportsPath
      } else if (node.objectType === 'Proposal') {
        path = proposalPath
      } else if (node.objectType === 'Invoice') {
        path = invoicesPath
      }
      const fullPath = makeSearchPath(path, {
        customerId: node.customerId,
        id: isCustomer ? '' : node.id,
      })
      navigate(fullPath)
    },
    [navigate],
  )

  const getIcon = useCallback((type: Maybe<string>) => {
    if (!type || type.toLowerCase() === 'deal') return 'icon-document'
    if (type.toLowerCase() === 'report') return 'icon-file'

    return `icon-${type.toLowerCase()}`
  }, [])

  return (
    <tbody>
      {data.map(
        datum =>
          datum.node && (
            <tr
              key={`${datum.node.label}-${datum.node.id}`}
              onClick={() => onClickRow(datum.node)}
            >
              <td>
                <span className={getIcon(datum.node.objectType)}></span>
                {datum.node.label}
              </td>
              <td>
                {datum.node.creationTime
                  ? moment(datum.node.creationTime).format('dd/MM/yyyy HH:mm')
                  : '-'}
              </td>
              <td>{datum.node.id}</td>
              <td>
                {/* @ts-ignore */}
                {datum.node?.status ? (
                  <span
                    className="status active"
                    style={{ borderColor: '#6fcf97' }}
                  >
                    {/* @ts-ignore */}
                    {datum.node?.status || '-'}
                  </span>
                ) : (
                  <span>-</span>
                )}
              </td>
              <td></td>
              <td>
                <span className="section" style={{ background: '#f2994a' }}>
                  {datum.node.objectType}
                </span>
              </td>
            </tr>
          ),
      )}
    </tbody>
  )
}

export default TBody
